import type { AnyAction } from '@reduxjs/toolkit';

import type { AppDispatch, ReduxStateType, Selector } from 'Core/store';

export type StateChangedBy = (selector: Selector<unknown>) => boolean;

export interface EpicArg {
  state: ReduxStateType;
  dispatch: AppDispatch;
  stateChangedBy: StateChangedBy;
  action: AnyAction;
}

export type EpicResult = AnyAction | false | null | void | Promise<AnyAction | false | null | void>;

export type Epic = (arg: EpicArg) => EpicResult;

export const defaultEpicHandler = Symbol('default');

export function epicFromHandlers(handlers: Record<string | symbol, Epic>, name?: string): Epic {
  const epic: Epic = (arg) => (handlers[arg.action.type] || handlers[defaultEpicHandler])?.(arg);
  if (name) {
    Object.defineProperty(epic, 'name', { value: name, configurable: true });
  }
  return epic;
}
